class LogArchive {
    name: string;
    containerName: string;
    created: Date;
    lastModified: Date;
    expiryDate: Date

    constructor(data?: Partial<LogArchive>) {
        Object.assign(this, data);

        if (typeof this.created === "string")
            this.created = new Date(this.created);

        if (typeof this.lastModified === "string")
            this.lastModified = new Date(this.lastModified);

        if (typeof this.expiryDate === "string")
            this.expiryDate = new Date(this.expiryDate);
    }
}

export default LogArchive;